<fm-context-menu [position]="menuData.clickPosition"
  [isRightClickDisabled]="true"
  class="map-menu-container"
  (closed)="onMenuClosed()"
  (copyCoordinatesClicked)="onCopyCoordinates($event)"
  menuName="Suggested Geofence"
  [latLng]="menuData.markerInfo?.latLng"
  i18n-menuName="@@S_HOTSPOT">
  <fm-geofence-menu-content [menuData]="menuData"
    [userPermissions]="userPermissions"
    (closed)="onMenuClosed()"
    (findNearestClicked)="onFindNearestClicked()"
    (zoomToClicked)="onZoomToClicked()"
    (streetViewClicked)="onStreetViewClicked()"
    (editPlaceClicked)="onEditPlaceClicked()"
    (getDirectionToClicked)="onGetDirectionToClicked()"
    (getDirectionFromClicked)="onGetDirectionFromClicked()"
    (locationToGarminClicked)="onLocationToGarminClicked()"></fm-geofence-menu-content>
</fm-context-menu>
